import { createSlice } from '@reduxjs/toolkit'
import { ProfileGet,CompanyLogo,CompanyBanner,SocialUpdate,IntroUpdate, AddBranch, UpdateBranch } from '../api/ProfileApi'

const initialState = {
    profileData:[],
    introUpdate :[],
    branchData: [],
    loading:false,
}

export const ProfileSlice = createSlice({
  name: 'ProfileSlice',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {

       builder.addCase(ProfileGet.pending, (state, action) => {
        state.loading = true;
      })
      builder.addCase(ProfileGet.fulfilled , (state, action) => {
   
        state.profileData=action.payload;
        state.loading = false;
      })
      builder.addCase(ProfileGet.rejected, (state, action) => {
        state.loading = false;
      })

      // company logo update----

      builder.addCase(CompanyLogo.pending, (state, action) => {
        state.loading = true;
      })
      builder.addCase(CompanyLogo.fulfilled , (state, action) => {
        state.loading = false;
      })
      builder.addCase(CompanyLogo.rejected, (state, action) => {
        state.loading = false;
      })

       // company banner update----

       builder.addCase(CompanyBanner.pending, (state, action) => {
        state.loading = true;
      })
      builder.addCase(CompanyBanner.fulfilled , (state, action) => {
        state.loading = false;
      })
      builder.addCase(CompanyBanner.rejected, (state, action) => {
        state.loading = false;
      })

       // socail Media update----

       builder.addCase(SocialUpdate.pending, (state, action) => {
        state.loading = true;
      })
      builder.addCase(SocialUpdate.fulfilled , (state, action) => {
        state.loading = false;
      })
      builder.addCase(SocialUpdate.rejected, (state, action) => {
        state.loading = false;
      })

      // socail IntroUpdate----

      builder.addCase(IntroUpdate.pending, (state, action) => {
        state.loading = true;
      })
      builder.addCase(IntroUpdate.fulfilled , (state, action) => {
        state.loading = false;
      })
      builder.addCase(IntroUpdate.rejected, (state, action) => {
        state.loading = false;
      })


      builder.addCase(AddBranch.pending, (state, action) => {
        state.loading = true;
      })

      builder.addCase(AddBranch.fulfilled, (state, action) => {
        state.loading = false;
        state.branchData = action?.payload
      })

      builder.addCase(AddBranch.rejected, (state, action) => {
        state.loading = false;
      })

      builder.addCase(UpdateBranch.pending, (state, action) => {
        state.loading = true;
      })

      builder.addCase(UpdateBranch.fulfilled, (state, action) => {
        state.loading = false;
        state.branchData = action?.payload
      })

      builder.addCase(UpdateBranch.rejected, (state, action) => {
        state.loading = false;
      })

  },

})



export default ProfileSlice.reducer